import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function PublicRoute({ component: Component, ...rest }) {

  return (<>

    {!rest.isAuthenticated && (
      <Route>
        <Component {...Component} />
      </Route>
    )}
    {rest.isAuthenticated && (
      <Route>
        <Redirect to={{ pathname: rest.redirectPath }} />
      </Route>
    )}

    {/* <Route {...rest} render={(props) => !rest.isAuthenticated ? <Component {...props} /> : <Redirect to={{ pathname: rest.redirectPath }} />}
    /> */}
  </>)
}
export default PublicRoute;